// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQIsReportSavePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import actions from './Izenda.NLQIsReportSavePopupActions';


@connect(actions)
class NLQIsReportSavePopup extends PureComponent {
  static propTypes = {
    onClosing: PropTypes.func.isRequired,
    localizer: PropTypes.object.isRequired,
    isExportClick: PropTypes.bool.isRequired
  };

  renderContainer = () => { 
    const { localizer, isExportClick } = this.props;
    return (
      <p>{ isExportClick ? localizer.getText('COMMON_LABEL_SAVE_REPORT_BEFORE_EXPORT_CONFIRMATION'): localizer.getText('COMMON_LABEL_SAVE_REPORT_BEFORE_DASHBOARD_CONFIRMATION')} </p>
    );
  };

  render() {
    const { onClosing, localizer } = this.props;
    const popupTitle = localizer.getText('COMMON_LABEL_SAVE_CONFIRMATION');
    return (
      <Popup visible onClosing={onClosing} autoClose={false} type='none' sizeClass='explore-modal'>
        <Popup.Header title={popupTitle} />
        <Popup.Body>{this.renderContainer()}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type='accept'>{localizer.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type='cancel'>
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default NLQIsReportSavePopup;



// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQIsReportSavePopup/Izenda.NLQIsReportSavePopup.js